;(function() {

	// *************************************************************************
	// Quantity buttons
	// *************************************************************************

	function updateQuantity(target, difference) {
		var input = target.closest(".input-group").querySelector("input");
		var value = (parseInt(input.value) || 0) + difference;
		if (value < 1) { value = 1; }
		input.value = value;
	}

	document.addEventSelectorListener("click", "[data-increase]", function(event, target) {
		event.preventDefault();
		updateQuantity(target, 1);
	});

	document.addEventSelectorListener("click", "[data-decrease]", function(event, target) {
		event.preventDefault();
		updateQuantity(target, -1);
	});

}());
